import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";

@Component({
  selector: 'app-safety-alert-modal',
  templateUrl: './safety-alert-modal.component.html',
  styleUrls: ['./safety-alert-modal.component.scss'],
  providers: [RilrService, HelperService],
})
export class SafetyAlertModalComponent implements OnInit {

  public reportSystemID: number;
  public companySystemID = this.helperService.getSelectedCompanyId();
  public masterData: any = {};
  public eventTitle: string = "";
  public country: string = "";
  public segment: string = "";
  public severityAccess: string = "";
  public whatHappened: string = "";
  public rootCauses: any[];
  public correctiveActions: any[];
  public attachments: any[];
  public innerHTML: string;

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private modalService: BsModalService,
              private spinner: NgxSpinnerService,
              private rilrService: RilrService) {
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
    }, 0);

  }

  public reportPrintPreview() {
    const that = this;
    that.rilrService
      .accidentReportSafetyAlert()
      .get({
        reportSystemID: that.reportSystemID,
      })
      .subscribe(data => {
        const resp = data.data.data;
        that.eventTitle = resp.eventTitle;
        that.country = resp.country;
        that.segment = resp.segment;
        that.severityAccess = resp.severityAccess;
        that.whatHappened = resp.incident;
        that.rootCauses = resp.rootCauses;
        that.correctiveActions = resp.actionTitles;
        that.attachments = resp.attachments;
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public checkAttachment(evt, incidentID) {
    this.attachments[incidentID].isChecked = evt.target.checked;
    var x = 0;
    this.attachments.forEach(function(a, i) {
      if (a.isChecked) {
        x++;
      }
    });
    setTimeout(() => {
      if (x > 2) {
        this.attachments[incidentID].isChecked = false;
      }
    }, 0);
  }

  public print_pdf() {
    const that = this;
    that.masterData.attachemnt = that.attachments;
    that.masterData.reportSystemID = that.reportSystemID;
    that.rilrService
      .accidentReportSafetyAlertPDF()
      .post(that.masterData)
      .subscribe(resp => {
        const data = resp.data.data;
        window.open(data.pdf_path, "_blank");
      }, (error) => {
        if (error.status == 500) {
        }
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/safety-alert-modal/safety-alert-modal.component.ts